import { AppConfig } from '@shared/services/settings.service';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if (environment.enableSentry) {
  Sentry.init({
    dsn: 'https://93cc3b506d0de9c25331d236225e21a0@o4510903524720640.ingest.de.sentry.io/4510903530160208',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: environment.production ? 'production' : 'development',
  });
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('./assets/pdf.worker.min.js').then(function () {});
}
// This approach causes a warning from angular-cli please ignore it
AppConfig.load()
  .then(() => import('./app/app.module'))
  .then((m) => {
    platformBrowserDynamic()
      .bootstrapModule(m.AppModule)
      .catch((err) => console.log(err));
  });
